import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-dataspace-report-status-badge',
  templateUrl: './dataspace-report-status-badge.component.html',
  styleUrls: ['./dataspace-report-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataspaceReportStatusBadgeComponent {
  @Input() status = '';

  get badgeClass(): string {
    switch ((this.status || '').trim().toUpperCase()) {
      case 'ENTWURF':
        return 'is-draft';
      case 'GESPEICHERT':
        return 'is-saved';
      case 'BEREIT ZUR FREIGABE':
      case 'FREIGEGEBEN':
      case 'FINALISIERT':
        return 'is-released';
      case 'AKTIVE VEREINBARUNG':
      case 'AKTIV':
        return 'is-delivered';
      case 'ZUGRIFF ANGEFRAGT':
      case 'ANFRAGE ERFORDERLICH':
      case 'WARTET AUF FREIGABE':
        return 'is-saved';
      case 'BEREITGESTELLT':
      case 'UEBERMITTELT':
        return 'is-delivered';
      case 'ABGELAUFEN':
      case 'ARCHIVIERT':
        return 'is-neutral';
      case 'ABGELEHNT':
      case 'WIDERRUFEN':
        return 'is-revoked';
      case 'NEUERE VERSION':
      case 'EINGEGANGEN':
        return 'is-received';
      default:
        return 'is-neutral';
    }
  }
}
